import { useContext } from "react";
import { TStyleConnotation } from "../../../types";
import { Alert, FormRow, Link, Typography } from "../../util";
import { LocationContext } from "../../../contexts";
import { urls } from "../../../config/appConfig";

export const AlertBox = ({ message, color }: iAlertBoxProps) => {
  let includeLink = false;
  let includeLogin = false;

  const { urlParams } = useContext(LocationContext);

  let loginLink = "/login";
  if (urlParams?.visitor_role) {
    loginLink = `/login?visitor_role=${urlParams.visitor_role}`;
  }

  const contactUs = <Link href={urls.careContact}>contact Care</Link>;

  const login = (
    <>
      {" "}
      <Link href={loginLink}>Login</Link>
    </>
  );

  if (message.includes("contact Care")) {
    includeLink = true;
    message = message.replaceAll("contact Care", " ");
  } else if (message.toLowerCase().includes("account already exists")) {
    includeLogin = true;
  }

  return (
    <>
      <FormRow>
        <Alert color={color}>
          <Typography>
            {message}
            {includeLink && contactUs}
            {includeLogin && login}
          </Typography>
        </Alert>
      </FormRow>
    </>
  );
};

export interface iAlertBoxProps {
  message: any | string;
  color: TStyleConnotation;
}
